import { render, staticRenderFns } from "./Pakhsh.vue?vue&type=template&id=63640a9d"
import script from "./Pakhsh.vue?vue&type=script&lang=js"
export * from "./Pakhsh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports